import RICH88EGAMEActions from './RICH88EGAMEActions'

export default class RICH88TABLEActions extends RICH88EGAMEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'TABLE',
      gameCode: 'RICH88-TABLE-001',
      platform: 'RICH88',
    }

    this.gameName = 'Big and Small'
    this.roundIdSuffix = 'AC-FT001'
  }
}
